import type { CSSProperties, FC } from 'react';
import styled from 'styled-components';

import imagePlaceholder from '@/assets/icons/img-placeholder-gray.svg';
import Text from '@/components/Text';
import type { SocialPost } from '@/types/resources';

export const CheckboxHolder = styled.div`
  position: relative;
`;

export const CheckboxLabel = styled.label`
  display: block;
  height: 24px;
  width: 24px;
  right: 10px;
  border: 2px solid ${({ theme }) => theme.colors.gray};
  background-color: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  transition: border-color ease-out 0.2s;
  &:hover {
    border-color: ${({ theme }) => theme.colors.purpleLighter};
  }
`;

export const Checkbox = styled.input`
  display: none;
  &:checked + ${CheckboxLabel} {
    background: ${({ theme }) => theme.colors.purple};
    border-color: transparent;
    &:after {
      content: '';
      position: absolute;
      left: 8px;
      top: 3px;
      width: 8px;
      height: 14px;
      border: solid ${({ theme }) => theme.colors.white};
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
    }
  }
`;

const Row = styled.div`
  display: grid;
  padding: 16px 24px;
  gap: 24px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGray};
  align-items: center;
  grid-template-columns: repeat(4, minmax(0, 1fr));
`;

const Column = styled.div`
  word-wrap: break-word;
`;

const ImageColumn = styled(Column)`
  display: flex;
  gap: 24px;
  align-items: center;
`;

const Image = styled.img`
  width: 122px;
  height: 94px;
  object-fit: contain;
`;

interface Props {
  style: CSSProperties;
  post: SocialPost;
  isChecked: boolean;
  onCheck: () => void;
}

const PostRow: FC<Props> = ({ post, style, isChecked, onCheck }) => {
  return (
    <Row style={style}>
      <ImageColumn>
        <CheckboxHolder>
          <Checkbox
            id={`post-${post.id}`}
            name="products"
            type="checkbox"
            checked={isChecked}
            onChange={onCheck}
          />
          <CheckboxLabel htmlFor={`post-${post.id}`} />
        </CheckboxHolder>
        <a target="_blank" rel="noreferrer noopener" href={post.permalink}>
          <Image
            src={
              post.image?.versions.preview ??
              post.image?.versions.original ??
              imagePlaceholder
            }
            alt=""
          />
        </a>
      </ImageColumn>
      <Column>
        <Text $type="smallBold">{post.message ?? '-'}</Text>
      </Column>
      <Column>
        <Text $type="smallBold">{post.likes}</Text>
      </Column>
      <Column>
        <Text $type="smallBold">{post.author}</Text>
      </Column>
    </Row>
  );
};

export default PostRow;
